import { pathOr } from 'ramda';

import { types } from './actions';
import { MODES } from './constants';

const initialState = {
  isLoading: false,
  isOpen: false,
  isSaving: false,
  mode: MODES.CREATE,
  workStep: undefined,
  workStepId: undefined,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.CLOSE:
      return initialState;
    case types.SET_WORK_STEP:
      return {
        ...state,
        workStep: payload.workStep,
      };
    case types.OPEN_ERROR:
      return {
        ...state,
        isLoading: false,
        isOpen: false,
      };
    case types.OPEN_REQUEST:
      return {
        ...state,
        isLoading: true,
        isOpen: true,
        mode: pathOr(MODES.CREATE, ['mode'], payload),
        workStepId: pathOr(null, ['workStepId'], payload),
      };
    case types.OPEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case types.SAVE_ERROR:
      return {
        ...state,
        isSaving: false,
      };
    case types.SAVE_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case types.SAVE_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.workflows.workStepModal;

export const getWorkStep = (state) => getScope(state).workStep;

export const getWorkStepId = (state) => getScope(state).workStepId;

export const getIsLoading = (state) => getScope(state).isLoading;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsSaving = (state) => getScope(state).isSaving;

export const getMode = (state) => getScope(state).mode;
